var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.544 11.348C21.848 11.7743 22 11.9875 22 12.303C22 12.6185 21.848 12.8317 21.544 13.258C20.1779 15.1736 16.6892 19.303 12 19.303C7.31078 19.303 3.8221 15.1736 2.45604 13.258C2.15201 12.8317 2 12.6185 2 12.303C2 11.9875 2.15201 11.7743 2.45604 11.348C3.8221 9.43242 7.31078 5.30298 12 5.30298C16.6892 5.30298 20.1779 9.43242 21.544 11.348Z",
    stroke: "#C0C0C0",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 12.303C15 10.6461 13.6569 9.30298 12 9.30298C10.3431 9.30298 9 10.6461 9 12.303C9 13.9599 10.3431 15.303 12 15.303C13.6569 15.303 15 13.9599 15 12.303Z",
    stroke: "#C0C0C0",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.a884daf1d022d07b7199786c305e2522.svg";
export { ForwardRef as ReactComponent };